import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import makeStyles from '@mui/styles/makeStyles';
import moment from "moment";
import { useOrderFlow } from "../../../OrderFlowProvider/OrderFlowContext";
import { Box, Typography } from "@mui/material";
import { ActionTypes } from "../../../OrderFlowProvider/OrderFlowActionTypes";
import { MakeAccordian } from "./MakeAccordion";
import { JSONDisplay } from "./JSONDisplay";
import { useDebugModule } from "./useDebugModule";
import { shouldDisableDate } from "../StartDate/useStartDate";
const useStyles = makeStyles(() => ({
    root: {
        "& .MuiInputBase-input, .MuiInputBase-input:hover, .MuiInputBase-input:focus": {
            border: "none !important",
            background: "none !important",
            font: "inherit !important",
        },
    },
}));
/**
 * Displays module and store data for easier debugging
 */
export const Debug = () => {
    const { store, dispatch } = useOrderFlow();
    const classes = useStyles();
    const { propagateChange, dateParse } = useDebugModule();
    const [debugDaysOfWeek, setDebugDaysOfWeek] = useState("");
    const [debugStartDate, setDebugStartDate] = useState("");
    const [debugSelectedDay, setDebugSelectedDay] = useState("");
    const [debugRecipeType, setDebugRecipeType] = useState("");
    const [debugOmissions, setDebugOmissions] = useState("");
    const debugStartDateRef = useRef("");
    const debugSelectedDayRef = useRef("");
    const [debugDaysOfWeekError, setDebugDaysOfWeekError] = useState(false);
    const [debugStartDateError, setDebugStartDateError] = useState(false);
    const [debugSelectedDayError, setDebugSelectedDayError] = useState(false);
    const [debugRecipeTypeError, setDebugRecipeTypeError] = useState(false);
    const [debugOmissionsError, setDebugOmissionsError] = useState(false);
    useEffect(() => {
        setDebugDaysOfWeek(JSON.stringify(store.cart.daysOfWeek));
    }, [store.cart.daysOfWeek]);
    useEffect(() => {
        if (store.cart.startDate && !moment(store.cart.startDate).isSame(debugStartDateRef.current, "date")) {
            let dateStr = moment(store.cart.startDate).format("MM/DD/YYYY");
            setDebugStartDate(dateStr);
            debugStartDateRef.current = dateStr;
        }
    }, [store.cart.startDate]);
    useEffect(() => {
        if (store.cart.selectedDay && !moment(store.cart.selectedDay).isSame(debugSelectedDayRef.current, "date")) {
            let dateStr = moment(store.cart.selectedDay).format("MM/DD/YYYY");
            setDebugSelectedDay(dateStr);
            debugSelectedDayRef.current = dateStr;
        }
    }, [store.cart.selectedDay]);
    useEffect(() => {
        setDebugRecipeType(JSON.stringify(store.cart.recipeType, null, 2));
    }, [store.cart.recipeType]);
    useEffect(() => {
        setDebugOmissions(JSON.stringify(store.cart.omissions, null, 2));
    }, [store.cart.omissions]);
    return (_jsxs(Box, Object.assign({ className: classes.root }, { children: [_jsx(Typography, { children: "Debug Menu" }), _jsx(JSONDisplay, { name: "Days of Week", value: debugDaysOfWeek, onChange: (event) => {
                    setDebugDaysOfWeek(event.target.value);
                    propagateChange(event.target.value, ActionTypes.SET_DAYS_OF_WEEK, setDebugDaysOfWeekError, JSON.parse, dispatch);
                }, error: debugDaysOfWeekError }), _jsx(JSONDisplay, { name: "Start Date", value: debugStartDate, onChange: (event) => {
                    setDebugStartDate(event.target.value);
                    debugStartDateRef.current = event.target.value;
                    propagateChange(event.target.value, ActionTypes.SET_START_DATE, setDebugStartDateError, (val) => {
                        let date = dateParse(val);
                        if (shouldDisableDate(store.model.DeliveryScheduleMealDays, store.cart.daysOfWeek, store.model.DeliveryDays, store.model.GeneralSettings.OnlyShowDeliveryDays))
                            throw new Error("Invalid Date");
                        return date;
                    }, dispatch);
                }, error: debugStartDateError }), _jsx(JSONDisplay, { name: "Meals", value: JSON.stringify(store.cart.meals, null, 2) }), _jsx(JSONDisplay, { name: "Selected Day", value: debugSelectedDay, onChange: (event) => {
                    setDebugSelectedDay(event.target.value);
                    debugSelectedDayRef.current = event.target.value;
                    propagateChange(event.target.value, ActionTypes.SET_SELECTED_DAY, setDebugSelectedDayError, dateParse, dispatch);
                }, error: debugSelectedDayError }), _jsx(JSONDisplay, { name: "Recipe Type", value: debugRecipeType, onChange: (event) => {
                    setDebugRecipeType(event.target.value);
                    propagateChange(event.target.value, ActionTypes.SET_RECIPE_TYPE, setDebugRecipeTypeError, JSON.parse, dispatch);
                }, error: debugRecipeTypeError }), _jsx(JSONDisplay, { name: "Meal Bundles", value: JSON.stringify(store.cart.bundles, null, 2) }), _jsx(JSONDisplay, { name: "Omissions", value: debugOmissions, onChange: (event) => {
                    setDebugOmissions(event.target.value);
                    propagateChange(event.target.value, ActionTypes.SET_OMISSIONS, setDebugOmissionsError, JSON.parse, dispatch);
                }, error: debugOmissionsError }), _jsx(MakeAccordian, { name: "Is Subscription", details: _jsx("input", { type: "checkbox", checked: store.cart.isSubscription, onChange: (event) => dispatch({ type: ActionTypes.SET_IS_SUBSCRIPTION, payload: event.target.checked }) }) }), _jsx(JSONDisplay, { name: "Template", value: JSON.stringify(store.cart.template, null, 2) }), _jsx(JSONDisplay, { name: "Recipes", value: JSON.stringify(store.model.Recipes, null, 2) }), _jsx(JSONDisplay, { name: "Delivery Days", value: JSON.stringify(store.model.DeliveryDays, null, 2) })] })));
};
